<h2 mat-dialog-title>Er ging iets mis</h2>
<mat-dialog-content>
  <p>Er ging iets mis, probeer het later nog eens. Indien het probleem blijft bestaan neem dan contact met ons op.</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" mat-dialog-close cdkFocusInitial>Ok</button>
</mat-dialog-actions>
